import type {CurrentAuthService, FinishedResponseInteractionService, WalkerService} from 'shared/services';
import {FileViewForm} from 'shared/constants';
import type {Rec, UUID, ViewableFile} from 'src/typings';
import type {IWindowService} from 'angular';
import type {FileService} from '../../file/file.service';
import type {RecordCoverDataService} from './record-cover.data-service';
import {exists} from 'shared/utils/custom-utils';

export class RecordCoverService {
    public static serviceName = 'recordCoverService';

    /*@ngInject*/
    constructor(private fileService: FileService,
                private walker: WalkerService,
                private $window: IWindowService,
                private currentAuthService: CurrentAuthService,
                private recordCoverDataService: RecordCoverDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public openMediaViewer(record: Rec): Promise<string> {
        return this.walker.newPage('/media-viewer', {
            rootDirectory: record.directoryId,
            origin: this.$window.location.href
        });
    }

    public getCoverPath(record: Rec | null): string {
        if (exists(record)) {
            return this.getRecordCoverPath(record);
        } else {
            return this.placeholderCoverPath;
        }
    }

    public getRecordPath(record: Rec): string {
        return `/#!/records/${record.id}`;
    }

    public async setFileAsPrimaryCover(record: Rec, file: ViewableFile): Promise<boolean> {
        if (!file.viewForms.includes(FileViewForm.IMAGE)) {
            return false;
        }

        try {
            const actionResponse = await this.recordCoverDataService.setFileAsPrimaryCover({record, file});
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            return true;
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
            return false;
        }
    }

    public async uploadNewCoverImage(recordId: UUID, image: File): Promise<boolean> {
        try {
            await this.recordCoverDataService.uploadNewCoverImage({record: recordId, fileData: image});
            return true;
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
            return false;
        }
    }

    private getRecordCoverPath(record: Rec): string {
        if (exists(record.cover) && exists(record.cover.id)) {
            return `${this.fileService.getFilePath(record.cover)}/thumbnail`;
        } else {
            return `/records/${record.id}/cover`;
        }
    }

    public get isUserLoggedIn(): boolean {
        return this.currentAuthService.isLoggedIn();
    }

    private get placeholderCoverPath(): string {
        return '/resources/img/covers/book.png';
    }
}